var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.585,63.686c0.093,0.093,0.196,0.177,0.306,0.25c0.049,0.033,0.103,0.056,0.155,0.084c0.063,0.034,0.123,0.072,0.19,0.1 c0.066,0.027,0.135,0.043,0.203,0.063c0.057,0.017,0.112,0.039,0.171,0.051c0.129,0.026,0.26,0.039,0.392,0.039 s0.262-0.014,0.392-0.039c0.06-0.012,0.115-0.034,0.173-0.051c0.067-0.02,0.135-0.035,0.2-0.062 c0.069-0.028,0.131-0.067,0.196-0.103c0.049-0.027,0.101-0.049,0.148-0.081c0.11-0.074,0.213-0.157,0.307-0.251l7.399-7.399 c0.781-0.781,0.781-2.047,0-2.828s-2.047-0.781-2.828,0L50,57.445V24.817c0-1.104-0.896-2-2-2s-2,0.896-2,2v32.628l-3.987-3.987 c-0.781-0.781-2.048-0.781-2.828,0c-0.781,0.781-0.781,2.047,0,2.828L46.585,63.686z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.605,69.183h-31.21c-1.104,0-2,0.896-2,2s0.896,2,2,2h31.21c1.104,0,2-0.896,2-2S64.71,69.183,63.605,69.183z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cdd81a494a3f0d165536285c8a23baf3.svg";
export { ForwardRef as ReactComponent };